module.exports = __webpack_public_path__ + "static/media/chill-spins-600x200-dark.787ddb5d.png";